class CrimeObject {
    id: string;
    title: string;
    constructor(id: string, title: string) {
        this.id = id;
        this.title = title;
    }

    /**
     * Возвращает объект из JSON строки либо null если структура не соответвует модели
     * @param jsonStr объкт в формате JSON строки
     */
    static fromQR(jsonStr: string): CrimeObject | null {
        try {
            const json = JSON.parse(jsonStr);
            if (json.id !== undefined && json.title !== undefined) {
                return new CrimeObject(json.id, json.title);
            }
        } catch (e) {
            console.error(e);
        }
        return null;
    }
}

export default CrimeObject;